<template>
  <section>
    <base-model :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-model>
    <base-model :show="isLoading" title="Loading..." fixed>
      <base-spinner></base-spinner>
    </base-model>
    <div class="buttons">
      <base-button to="newEmployee" link>New Employee</base-button>
    </div>
    <div class="container">
      <div class="left">
        <global-card>
          <h2 v-if="employeeList.length === 0">Employee List is empty...</h2>
          <transition-group name="card" tag="table" v-else>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Technologies</th>
              <th>Contact</th>
              <th>Personal Email Id</th>
              <th>Company Email Id</th>
              <th>Address</th>
            </tr>
            <tr
              class="card"
              v-for="emp in employeeList"
              :key="emp.id"
              @click="viewEmployee(emp.id)"
            >
              <td>{{ emp.empId }}</td>
              <td>{{ emp.name }}</td>
              <td>{{ emp.designation }}</td>
              <td>
                <base-badge
                  v-for="tec in emp.tech"
                  :key="tec"
                  :type="tec"
                  :title="tec"
                ></base-badge>
              </td>
              <td>{{ emp.contact }}</td>
              <td>
                <a :href="'mailto:' + emp.personalEmail">{{
                  emp.personalEmail
                }}</a>
              </td>
              <td>
                <a :href="'mailto:' + emp.companyEmail">{{
                  emp.companyEmail
                }}</a>
              </td>
              <td>{{ emp.address }}</td>
            </tr>
          </transition-group>
        </global-card>
      </div>
      <div class="right">
        <global-card>
          <h2 v-if="!employee">Select Employee For Detail</h2>
          <div v-else>
            <h2>{{ employee.name }}</h2>
            <span>{{ employee.empId }}</span>
            <div class="boxer">
              <h3>Designation</h3>
              <p>{{ employee.designation }}</p>
            </div>
            <div class="boxer">
              <h3>Experience in</h3>
              <p>
                <base-badge
                  v-for="tec in employee.tech"
                  :key="tec"
                  :type="tec"
                  :title="tec"
                ></base-badge>
              </p>
            </div>
            <div class="boxer">
              <h3>Contact Number</h3>
              <p>{{ employee.contact }}</p>
            </div>
            <div class="boxer">
              <h3>Personal Email</h3>
              <p>{{ employee.personalEmail }}</p>
            </div>
            <div class="boxer">
              <h3>Company Email</h3>
              <p>{{ employee.companyEmail }}</p>
            </div>
            <div class="boxer">
              <h3>Address</h3>
              <p>{{ employee.address }}</p>
            </div>
            <div class="boxer">
              <ul class="boxControl">
                <li><base-button link :to="routeLink">Edit</base-button></li>
                <li>
                  <base-button @click="deleteEmployee(employee.id)"
                    >Delete</base-button
                  >
                </li>
              </ul>
            </div>
          </div>
        </global-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      employee: null,
      error: null,
      isLoading: false,
    };
  },
  computed: {
    employeeList() {
      return this.$store.getters["employees/getEmployees"];
    },
    routeLink() {
      return "/newEmployee/" + this.employee.id;
    },
  },
  created() {
    this.setEmployees();
  },
  methods: {
    deleteEmployee(id) {
      this.$store.dispatch("employees/deleteEmployee", id);
    },
    viewEmployee(id) {
      this.employee = this.employeeList.find((x) => x.id === id);
    },
    async setEmployees() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("employees/setEmployees");
      } catch (err) {
        this.error = err.message || "Failed to load Employees Try again";
      }
      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
.buttons {
  padding: 30px;
  box-sizing: border-box;
  text-align: left;
}
.container {
  float: left;
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
}
.left {
  width: 68%;
  float: left;
}
.right {
  width: 30%;
  float: left;
  margin-left: 2%;
}
table {
  border-collapse: collapse;
}
table tr:nth-child(odd) {
  background: #f1f1f1;
}
table tr:first-child {
  background: #323232;
}
table th {
  background: #323232;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  box-sizing: border-box;
  padding: 10px 0px;
}
table td {
  font-size: 14px;
  box-sizing: border-box;
  padding: 10px;
}
table td a {
  color: purple;
  text-decoration: none;
}
.boxControl {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.boxControl li {
  display: inline-block;
  width: 50%;
}
.boxer {
  padding: 5px;
  box-sizing: border-box;
}
.card {
  transition: all 0.5s;
}
.card-enter,
.card-leave-to {
  opacity: 0;
  transform: scale(0);
}
.card-enter-to {
  opacity: 1;
  transform: scale(1);
}

.card-leave-active {
  /*position: absolute;*/
}

.card-move {
  opacity: 1;
  transition: all 0.5s;
}
</style>
